<!--
 * @Description: 机构注册详情组件
 * @Author: wanqian
 * @Date: 2022-05-19 16:43:52
-->
<template>
	<div class="body">
		<!-- status审核状态：0-未审核 1-审核通过 2-审核拒绝 3-撤回 -->
		<div class="success-submit" v-if="reviewResult && reviewResult.status == 0">
			<i class="el-icon-success" style="color: #55C22A; font-size: 30px;"></i>
			<span class="success-text">您已成功提交审核，请耐心等待1-2个工作日。即时查看审核动态</span>
		</div>
		<div v-else-if="reviewResult && reviewResult.status == 1">
			<review-result :review="reviewResult" />
		</div>
		<div>
			<div class="section-item mng-message" v-if="reviewResult && reviewResult.status == 1">
				<div class="section-item-head">
					<div class="blue-line"></div>
					<span>{{title}}</span>
				</div>
				<div class="mng-body">
					<el-row type="flex" align="middle">
						<img class="icon-mng icon-mng-url" src="../../../assets/login/instreg/icon-instreg-url.png" alt="">
						<el-link v-if="details && details.institutionDO && details.institutionDO.baseInfoDO" type="primary" 
							class="link" :underline="false" target="_blank" :href="details.institutionDO.baseInfoDO.landingUrl">
							{{details.institutionDO.baseInfoDO.landingUrl}}
						</el-link>
					</el-row>
					<el-row type="flex" :gutter="70" align="middle" class="mng-account">
						<el-col :span="8">
							<div class="mng-account-left">
								<img class="icon-mng icon-mng-account" src="../../../assets/login/instreg/icon-instreg-account.png" 
									alt="">
								<div>账户名：{{details.userName}}</div>
							</div>
						</el-col>
						<el-col :span="8">
							<div class="mng-account-center">
								<img class="icon-mng icon-mng-passwd" src="../../../assets/login/instreg/icon-instreg-passwd.png" 
									alt="">
								<div>初始密码：{{details.defaultPassword}}</div>
							</div>
						</el-col>
						<el-col :span="8">
							<div class="mng-account-right">
								<img class="icon-mng icon-mng-mobile" src="../../../assets/login/instreg/icon-instreg-mobile.png" 
									alt="">
								<div>
									客服电话：{{details.platformPhone && details.platformPhone.length ? details.platformPhone[0] : '- -'}}
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
			<div class="section-iteme homepage-message" style="margin-top: 30px;" 
				v-if="reviewResult && reviewResult.status == 1 && details && details.institutionDO 
					&& details.institutionDO.baseInfoDO && details.institutionDO.baseInfoDO.institutionMainPageUrl">
				<div class="section-item-head">
					<div class="blue-line"></div>
					<span>机构主页地址（支持嵌入机构微信公众号中）</span>
				</div>
				<div class="homepage-body">
					<el-row type="flex" align="middle">
						<img class="icon-mng icon-mng-url" src="../../../assets/login/instreg/icon-instreg-url.png" alt="">
						<span style="word-break: break-all;">{{details.institutionDO.baseInfoDO.institutionMainPageUrl}}</span>
						<img src="@/assets/common/icon-common-copy.png" alt=""
                class="btn-copy mouse-pointer" @click="handleCopyHomePageUrl">
					</el-row>
				</div>
			</div>
			<div class="section-item person-message">
				<div class="section-item-head">
					<div class="blue-line"></div>
					<span>个人信息</span>
				</div>
				<el-descriptions class="margin-top" :column="2" :labelStyle="labelStyle" :contentStyle="contentStyle">
					<el-descriptions-item label="姓名">{{details.adminName}}</el-descriptions-item>
					<el-descriptions-item label="账户名">{{details.userName}}</el-descriptions-item>
					<el-descriptions-item label="手机号">{{details.mobile}}</el-descriptions-item>
				</el-descriptions>
			</div>
			<div class="section-item inst-message">
				<div class="section-item-head">
					<div class="blue-line"></div>
					<span>机构信息</span>
				</div>
				<el-descriptions class="margin-top" :column="2" :labelStyle="labelStyle" :contentStyle="contentStyle">
					<el-descriptions-item label="机构名称">{{institution.name}}</el-descriptions-item>
					<el-descriptions-item label="机构所在省">{{institution.province}}</el-descriptions-item>
					<el-descriptions-item label="机构所在市">{{institution.city}}</el-descriptions-item>
					<el-descriptions-item label="机构所在县">{{institution.county}}</el-descriptions-item>
					<el-descriptions-item label="机构地址">{{institution.addr}}</el-descriptions-item>
				</el-descriptions>
				<el-descriptions class="margin-top" :column="2" :labelStyle="labelStyle" :contentStyle="contentStyle">
					<el-descriptions-item label="统一社会信用代码">{{institution.bizLicense}}</el-descriptions-item>
					<el-descriptions-item label="法人代表">{{institution.legalPerson}}</el-descriptions-item>
					<el-descriptions-item label="联系人姓名">{{institution.contact}}</el-descriptions-item>
					<el-descriptions-item label="联系电话">{{institution.contactNum}}</el-descriptions-item>
					<el-descriptions-item label="客服姓名">{{institution.csr}}</el-descriptions-item>
					<el-descriptions-item label="客服电话">{{institution.csTeleno}}</el-descriptions-item>
					<el-descriptions-item label="营业执照">
						<el-image v-if="institution.licensePath" style="width: 240px; height: 170px; background-color: #EBEEF2;" 
							:src="picPath" fit="contain" :preview-src-list="previewImgList" />
						<span v-else>无</span>
					</el-descriptions-item>
					<el-descriptions-item label="机构logo">
						<el-image v-if="institution.logoPath" style="width: 65px; height: 65px; background-color: #EBEEF2;" 
							:src="logoPath" fit="contain" :preview-src-list="previewImgList" />
						<span v-else>无</span>
					</el-descriptions-item>
				</el-descriptions>
			</div>
			<div class="section-item open-service" v-if="details.institutionDO">
				<div class="section-item-head">
					<div class="blue-line"></div>
					<span>服务开通</span>
				</div>
				<el-descriptions class="margin-top" :column="2" :labelStyle="labelStyle" :contentStyle="contentStyle">
					<el-descriptions-item v-for="openingHsvc in details.institutionDO.openingHsvcList" 
						:key="openingHsvc.id" :label="openingHsvc.hsvcCategoryText">
						{{openingHsvc.startTime + ' 至 ' + openingHsvc.endTime}}
					</el-descriptions-item>
				</el-descriptions>
			</div>
		</div>
	</div>
</template>

<script>
import Constant from '@/global/Constant.js'
import ReviewResult from '../../common/components/ReviewResult.vue'

export default {
  name: 'InstRegDetails',
  props: ['reviewResult'],
  
  components: {
    'review-result': ReviewResult,
  },

  data() {
    return {
      labelStyle: {'margin-top': '30px'},
      contentStyle: {'margin-top': '30px'},
      details: {},
      institution: {},
			title: '星护云管理平台'
    }
  },
  
  computed: {
    picPath() {
      return this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.institution.licensePath);
    },

    logoPath() {
      return this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.institution.logoPath);
    },

		previewImgList() {
      let imgList = [];
      if (this.institution.licensePath) {
        imgList.push(this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.institution.licensePath));
      }
      if (this.institution.logoPath) {
        imgList.push(this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.institution.logoPath));
      }
      return imgList;
    }
  },

  methods:{
    getDetails() {
      // status审核状态：0-未审核 1-审核通过 2-审核拒绝 3-撤回
			let params = {id: this.reviewResult.institutionId};
			let header = this.encryptionUtil.signatureParams(params,
				Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET', 
        url: Constant.URL_GET_REGISTER_INSTITUTION_DETAILS,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
      this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.details = result.data;
          this.institution = this.details.institutionDO.baseInfoDO.institution;
        }
      })
    },

		handleCopyHomePageUrl() {
			this.commonUtil.copyTextToBoard(this, this.details.institutionDO.baseInfoDO.institutionMainPageUrl);
		},
  },

  mounted() {
    this.getDetails();

		this.$nextTick(() => {
      if (process.env.NODE_ENV == 'sdjk' || process.env.NODE_ENV == 'sdjktest') {
        this.title = '悠心陪护后台'
      } else {
        this.title = '星护云管理平台'
      }
    });
  }
}
</script>

<style scoped>
.body {
  margin: 0;
  padding: 80px 50px;
  text-align: left;
  border: solid 0px;
}
.success-submit {
   display: flex;
   align-items: center;
}
.success-text {
  color: #55C22A;
  margin-left: 19px;
  font-size: 20px;
  line-height: 28px;
}
.section-item {
  margin-top: 30px;
}
.section-item-head {
  display: flex;
  align-items: center;
}
.section-item-head span {
  font-size: 15px;
  font-weight: 600;
  color: #000000;
}
.blue-line {
  width: 4px;
  height: 13px;
  background: #2A98FF;
  border-radius: 1px;
  margin-right: 12px;
}
.mng-message, .mng-body, .homepage-body {
  margin-top: 30px;
}
.mng-body .link {
  font-size: 15px;
  color: #2A98FF;
  line-height: 21px;
	font-weight: 400;
}
.icon-mng {
  margin-right: 13px;
}
.icon-mng-url {
  width: 19px;
  height: 16px;
}
.icon-mng-account {
  width: 16px;
  height: 19px;
}
.icon-mng-passwd {
  width: 16px;
  height: 20px;
}
.icon-mng-mobile {
  width: 19px;
  height: 18px;
}
.mng-account {
  margin-top: 15px;
	color: #000000;
	font-size: 15px;
	line-height: 21px;
}
.mng-account-left, .mng-account-center, .mng-account-right {
  display: flex;
  align-items: center;
	word-break: break-all;
}
.homepage-body {
	color: #000000;
	font-size: 15px;
}
.btn-copy {
	margin-left: 15px;
	width: 20px;
	height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/login/components/InstRegDetails.vue